<ng-template class="d-flex align-items-center" let-item="item">
    <div class="d-inline-flex align-items-center">
        <div class="d-flex mr-5px" [inlineSVG]="item.isPublic ? 'assets/image/users-icon.svg' : 'assets/image/lock-icon.svg'"></div>
    </div>
    {{item.name}}
</ng-template>
